import { render, staticRenderFns } from "./ReadyGoPlay.vue?vue&type=template&id=4b596789&"
import script from "./ReadyGoPlay.vue?vue&type=script&lang=js&"
export * from "./ReadyGoPlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports